/* eslint-disable */
import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import Cookies from "js-cookie";
import { FaFacebook, FaInstagram, FaTelegram, FaTwitter } from "react-icons/fa";

export default function Footer() {
	const [isLogin, setIsLogin] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		try {
			var access_data = Cookies.get("access");
			if (
				access_data != undefined &&
				access_data != null &&
				access_data != ""
			) {
				setIsLogin(true);
			} else {
				setIsLogin(false);
			}
		} catch {
			setIsLogin(false);
		}
	}, []);

	return (
		<footer className="border-t border-[rgba(147,197,253,0.14)] bg-[#080D1B]">
			<div className="landing-container px-4 py-12 lg:px-6 lg:py-16">
				<div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
					<div className="lg:col-span-4">
						<Link href="/" className="landing-brand inline-flex items-center">
							{t("kalonWallet")}
						</Link>
						<p className="mt-4 max-w-sm text-sm leading-relaxed text-kalon-muted">
							{t("index.trustedFinancialText")}
						</p>
					</div>

					<div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8 lg:grid-cols-3">
						<div>
							<h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-kalon-text">
								{t("landing.company")}
							</h3>
							<ul className="space-y-3 text-sm text-kalon-muted">
								<li>
									<Link
										href="/about"
										className="transition-colors hover:text-kalon-text">
										{t("landing.companyDetails")}
									</Link>
								</li>
								<li>
									<Link
										href="/about"
										className="transition-colors hover:text-kalon-text">
										{t("landing.mission")}
									</Link>
								</li>
								<li>
									<Link
										href="/about"
										className="transition-colors hover:text-kalon-text">
										{t("landing.values")}
									</Link>
								</li>
							</ul>
						</div>

						<div>
							<h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-kalon-text">
								{t("landing.resources")}
							</h3>
							<ul className="space-y-3 text-sm text-kalon-muted">
								<li>
									<Link
										href="/about"
										className="transition-colors hover:text-kalon-text">
										{t("about.aboutUs")}
									</Link>
								</li>
								<li>
									<Link
										href="/faqs"
										className="transition-colors hover:text-kalon-text">
										{t("faq.faqs")}
									</Link>
								</li>
								<li>
									<Link
										href="/contact-us"
										className="transition-colors hover:text-kalon-text">
										{t("landing.supportCenter")}
									</Link>
								</li>
								<li>
									<Link
										href="/contact-us"
										className="transition-colors hover:text-kalon-text">
										{t("contact.contactUs")}
									</Link>
								</li>
							</ul>
						</div>

						<div>
							<h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-kalon-text">
								{t("landing.legal")}
							</h3>
							<ul className="space-y-3 text-sm text-kalon-muted">
								<li>
									<Link
										href="/privacy"
										className="transition-colors hover:text-kalon-text">
										{t("privacy.policy")}
									</Link>
								</li>
								<li>
									<Link
										href="/terms"
										className="transition-colors hover:text-kalon-text">
										{t("terms.termsOfService")}
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div className="mt-12 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-6 sm:flex-row">
					<p className="text-sm text-kalon-muted">{t("landing.allRights")}</p>
					<div className="flex items-center gap-3">
						{[
							{ Icon: FaTwitter, label: "Twitter" },
							{ Icon: FaInstagram, label: "Instagram" },
							{ Icon: FaTelegram, label: "Telegram" },
							{ Icon: FaFacebook, label: "Facebook" },
						].map(({ Icon, label }) => (
							<Link
								key={label}
								href=""
								aria-label={label}
								className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[rgba(147,197,253,0.14)] bg-[#18243C] text-kalon-muted transition-colors hover:border-kalon-accent/40 hover:text-kalon-text">
								<Icon aria-hidden />
							</Link>
						))}
					</div>
				</div>
			</div>
		</footer>
	);
}
